import webStyle from "styled-components";

export const Receipt = webStyle.div`
    text-align: center;
    font-family: 'Courier New', Courier, monospace;
    width: 39ch;
    margin: auto;
`;
